import React from 'react';
import { Form, Message } from 'semantic-ui-react';

export const buildCacheCreationPrices = (prices) => {
  if (!prices) return undefined;
  const result = {};
  for (const ttl of ['5m', '1h']) {
    result[ttl] = {};
    for (const currency of ['usd', 'cny']) {
      const value = prices[ttl]?.[currency];
      if (value === '' || value == null) continue;
      if (!Number.isFinite(Number(value)) || Number(value) < 0) {
        throw new Error('缓存写入单价必须是非负数');
      }
      result[ttl][currency] = value;
    }
  }
  if (!Object.keys(result['5m']).length ||
      ['usd', 'cny'].some((currency) =>
        (result['5m'][currency] != null) !== (result['1h'][currency] != null))) {
    throw new Error('请填写币种一致的 5 分钟和 1 小时缓存写入价格');
  }
  return result;
};

const CacheCreationPricingEditor = ({ prices, onChange }) => {
  const checkboxId = React.useId();
  return (
  <>
    <Form.Checkbox
      id={checkboxId}
      label='分别设置 5 分钟和 1 小时缓存写入价格'
      checked={!!prices}
      onChange={(e, { checked }) => onChange(checked
        ? { '5m': { usd: '', cny: '' }, '1h': { usd: '', cny: '' } }
        : undefined)}
    />
    {prices && (
      <>
        <Message info size='small'>启用后使用下面的两种单价；原来的单一缓存写入价格不参与这项计费。</Message>
        {['5m', '1h'].map((ttl) => (
          <Form.Group widths='equal' key={ttl}>
            {['usd', 'cny'].map((currency) => (
              <Form.Input
                key={currency}
                label={`${ttl === '5m' ? '5 分钟' : '1 小时'}写入 ${currency.toUpperCase()} / 百万 Token`}
                type='number'
                min='0'
                step='0.000001'
                value={prices[ttl]?.[currency] ?? ''}
                onChange={(e, { value }) => onChange({
                  ...prices,
                  [ttl]: { ...prices[ttl], [currency]: value },
                })}
              />
            ))}
          </Form.Group>
        ))}
      </>
    )}
  </>
  );
};

export default CacheCreationPricingEditor;
